module.exports = __webpack_public_path__ + "static/img/5areaB_8.639bffc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_8.png
// module id = 1209
// module chunks = 1